import { createContext, useContext, useState } from "react";

const Context = createContext([]);

export function LightboxProvider({ children }) {
  const [image, setImage] = useState(null);
  function updateImage(update){
    setImage(update);
  }
  return (
	<Context.Provider value={[image, updateImage]}>
		{children}
	</Context.Provider>
  );
}

export function useLightboxContext() {
  return useContext(Context);
}